import React, { useEffect, useState } from 'react';
import {
  Button,
  Spin,
  Modal,
  Form,
  Input,
  Radio,
  Select,
  notification,
} from 'antd';
import { useDispatch } from 'react-redux';
import get from 'lodash/get';
import map from 'lodash/map';
import find from 'lodash/find';
import { LeftOutlined, PlusOutlined } from '@ant-design/icons';
import { productMangement } from '../../redux/actions/productAction';

const { Option } = Select;

function AddProductIngredients(props) {
  const { onSelectIngredient, selectedIngredients, companyId } = props;
  const [showLoginModal, setShowLoginModal] = useState(false);
  const [loading, setLoading] = useState(false);
  const [ingredients, setIngredients] = useState([]);
  const [section, setSection] = useState(1);
  const dispatch = useDispatch();

  const toggleModal = () => {
    setShowLoginModal(!showLoginModal);
  };

  const onSelectFinish = ({ id }) => {
    if (find(selectedIngredients, ['id', id])) {
      notification.error({
        message: 'This Ingredient is already selected!',
      });
      return;
    }
    onSelectIngredient(find(ingredients, ['id', id]));
    toggleModal();
  };

  const onCreateFinish = (value) => {
    setLoading(true);
    dispatch(
      productMangement('create.product_ingredient_type', {
        company_id: companyId,
        ...value,
      })
    )
      .then((result) => {
        onSelectIngredient(get(result, 'data'));
        toggleModal();
        setLoading(false);
      })
      .catch(() => {
        setLoading(false);
      });
  };

  const getIngredient = () => {
    setLoading(true);
    dispatch(
      productMangement('list.product_ingredient_types', {
        company_id: companyId,
      })
    )
      .then((result) => {
        setIngredients(get(result, 'data'));
        setLoading(false);
      })
      .catch(() => {
        setLoading(false);
      });
  };

  useEffect(() => {
    if (showLoginModal) {
      getIngredient();
    }
  }, [showLoginModal]);

  return (
    <>
      <Button
        className="add-categoty-link"
        icon={<PlusOutlined />}
        onClick={toggleModal}
        type="link"
      >
        Add Ingredient
      </Button>
      <Modal
        width="50%"
        className="common-modal product-image-modal "
        destroyOnClose
        closable={false}
        open={showLoginModal}
        onOk={toggleModal}
        onCancel={toggleModal}
        footer={null}
        maskClosable={false}
      >
        <Spin spinning={loading}>
          <div className="login-container">
            <div className="heading">
              <LeftOutlined
                className="back-btn"
                onClick={() => {
                  toggleModal();
                }}
              />
              Add Ingredient
            </div>
            <div className=" add-ingredient mt-40">
              <Radio.Group
                defaultValue={section}
                buttonStyle="solid"
                className="radio-btn"
                onChange={(e) => {
                  setSection(get(e, 'target.value'));
                }}
              >
                <Radio.Button value={1}>Select Ingredient</Radio.Button>
                <Radio.Button value={2}>Create a new Ingredient</Radio.Button>
              </Radio.Group>
              {section === 1 && (
                <Form
                  name="basic"
                  layout="vertical"
                  initialValues={{ remember: true }}
                  onFinish={onSelectFinish}
                  autoComplete="off"
                  requiredMark={false}
                >
                  <div className="mt-20">
                    <Form.Item
                      label="Ingredient"
                      name="id"
                      className="form-item"
                      rules={[
                        {
                          required: true,
                          message: 'Please select a ingredient!',
                        },
                      ]}
                    >
                      <Select placeholder="Select Ingredient" size="large">
                        {map(ingredients, (ingredient) => (
                          <Option
                            key={get(ingredient, 'id')}
                            value={get(ingredient, 'id')}
                            label={get(ingredient, 'name')}
                          >
                            {get(ingredient, 'name')}
                          </Option>
                        ))}
                      </Select>
                    </Form.Item>

                    <div className="mt-40">
                      <Button type="primary" block htmlType="submit">
                        Select
                      </Button>
                    </div>
                  </div>
                </Form>
              )}
              {section === 2 && (
                <Form
                  name="basic"
                  layout="vertical"
                  onFinish={onCreateFinish}
                  autoComplete="off"
                  requiredMark={false}
                >
                  <div className="mt-20">
                    <Form.Item
                      label="Ingredient Name"
                      name="name"
                      className="form-item"
                      rules={[
                        {
                          required: true,
                          message: 'Please input ingredient name!',
                        },
                        {
                          min: 3,
                          message:
                            'Ingredient name  should be of atleast 3 character!',
                        },
                      ]}
                    >
                      <Input size="large" placeholder="Enter Ingredient" />
                    </Form.Item>
                  </div>

                  <div className="mt-40">
                    <Button type="primary" block htmlType="submit">
                      Create
                    </Button>
                  </div>
                </Form>
              )}
            </div>
          </div>
        </Spin>
      </Modal>
    </>
  );
}

export default AddProductIngredients;
